export interface IMasterDataProduct {
  productId: number;
  productKey: string;
  itemName: string;
  itemDescription: string | null;
  upcItemNumber: string | null;
  glItemNumber: string | null;
  glItemDescription: string | null;
  isActive: boolean;
  categoryId: number | null;
  categoryName: string | null;
  categoryKey: string | null;
  uomId: number | null;
  uomCode: string | null;
  uomName: string | null;
  createdAt?: string | null;
  createdBy?: number | null;
  updatedAt?: string | null;
  updatedBy?: number | null;
}

export class MasterDataProduct {
  private readonly _productId: number;
  private readonly _productKey: string;
  private readonly _itemName: string;
  private readonly _itemDescription: string | null;
  private readonly _upcItemNumber: string | null;
  private readonly _glItemNumber: string | null;
  private readonly _glItemDescription: string | null;
  private readonly _isActive: boolean;
  private readonly _categoryId: number | null;
  private readonly _categoryName: string | null;
  private readonly _categoryKey: string | null;
  private readonly _uomId: number | null;
  private readonly _uomCode: string | null;
  private readonly _uomName: string | null;
  private readonly _createdAt: string | null;
  private readonly _createdBy: number | null;
  private readonly _updatedAt: string | null;
  private readonly _updatedBy: number | null;

  constructor(props: IMasterDataProduct) {
    this._productId = props.productId;
    this._productKey = props.productKey;
    this._itemName = props.itemName;
    this._itemDescription = props.itemDescription;
    this._upcItemNumber = props.upcItemNumber;
    this._glItemNumber = props.glItemNumber;
    this._glItemDescription = props.glItemDescription;
    this._isActive = props.isActive;
    this._categoryId = props.categoryId;
    this._categoryName = props.categoryName;
    this._categoryKey = props.categoryKey;
    this._uomId = props.uomId;
    this._uomCode = props.uomCode;
    this._uomName = props.uomName;
    this._createdAt = props.createdAt ?? null;
    this._createdBy = props.createdBy ?? null;
    this._updatedAt = props.updatedAt ?? null;
    this._updatedBy = props.updatedBy ?? null;
  }

  get productId(): number {
    return this._productId;
  }
  get productKey(): string {
    return this._productKey;
  }
  get itemName(): string {
    return this._itemName;
  }
  get itemDescription(): string | null {
    return this._itemDescription;
  }
  get upcItemNumber(): string | null {
    return this._upcItemNumber;
  }
  get glItemNumber(): string | null {
    return this._glItemNumber;
  }
  get glItemDescription(): string | null {
    return this._glItemDescription;
  }
  get isActive(): boolean {
    return this._isActive;
  }
  get categoryId(): number | null {
    return this._categoryId;
  }
  get categoryName(): string | null {
    return this._categoryName;
  }
  get categoryKey(): string | null {
    return this._categoryKey;
  }
  get uomId(): number | null {
    return this._uomId;
  }
  get uomCode(): string | null {
    return this._uomCode;
  }
  get uomName(): string | null {
    return this._uomName;
  }
  get createdAt(): string | null {
    return this._createdAt;
  }
  get createdBy(): number | null {
    return this._createdBy;
  }
  get updatedAt(): string | null {
    return this._updatedAt;
  }
  get updatedBy(): number | null {
    return this._updatedBy;
  }

  static from(props: IMasterDataProduct): MasterDataProduct {
    return new MasterDataProduct(props);
  }

  static toJSON(entity: MasterDataProduct): IMasterDataProduct {
    return {
      productId: entity.productId,
      productKey: entity.productKey,
      itemName: entity.itemName,
      itemDescription: entity.itemDescription,
      upcItemNumber: entity.upcItemNumber,
      glItemNumber: entity.glItemNumber,
      glItemDescription: entity.glItemDescription,
      isActive: entity.isActive,
      categoryId: entity.categoryId,
      categoryName: entity.categoryName,
      categoryKey: entity.categoryKey,
      uomId: entity.uomId,
      uomCode: entity.uomCode,
      uomName: entity.uomName,
      createdAt: entity.createdAt,
      createdBy: entity.createdBy,
      updatedAt: entity.updatedAt,
      updatedBy: entity.updatedBy,
    };
  }
}
